// Slugify a value for safe use in a download filename (alnum runs -> single '-').
// Mirrors the backend's sanitize_filename_part so client fallbacks match the
// server-provided Content-Disposition name.
export const slugifyFilenamePart = (value?: string | null): string =>
  (value || '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
